// extracted by mini-css-extract-plugin
export default {"contents":"oG-z","sectionHeading":"pG-z"};